import { useState, useEffect, useLayoutEffect, useContext } from "react";
import { AppContext } from "../App";

export default function useDOP() {
  const { location } = useContext(AppContext);
  const [popupVisible, setPopupVisible] = useState(false);
  const [dop, setDop] = useState("October 2024");

  useLayoutEffect(() => {
    const hcpPopup = document.querySelector(".hcp-popup-header");

    if (hcpPopup) {
      setPopupVisible(true);
    } else {
      setPopupVisible(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (popupVisible) {
      setDop("October 2024");
    } else {
      switch (location.pathname) {
        case "/hcp/":
        case "/hcp":
          setDop("August 2026");
          break;
        case "/hcp/contact-us":
          setDop("August 2026");
          break;
        case "/par":
        case "/par/":
          setDop("October 2025");
          break;
        case "/patient/useful-resources":
          setDop("October 2025");
          break;

        case "/patient/":
        case "/patient":
        case "/patient/how-to-apply-bunov":
        case "/patient/side-effects":
          setDop("October 2024");
          break;
        case "/hcp/initiating-bunov":
          setDop("August 2026");
          break;
        case "/hcp/pi":
          setDop("October 2025");
          break;
        case "/hcp/resources":
          setDop("August 2026");
          break;

        default:
          setDop("October 2024");
          break;
      }
    }
  }, [popupVisible, location.pathname]);

  return dop;
}
